<script>
  import { style, blocklist, text, richtext, image, url } from "../toolbox.js";
  import { link } from "svelte-routing";

  export let block;
</script>

<section style="{style(block)}">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-lg-10">
        <div class="card">
          <div class="table-responsive">
            <table class="table align-items-center mb-0">
              <thead>
                <tr>
                  <th class="text-uppercase text-secondary font-weight-bolder opacity-7">Tyrimų ID</th>
                  <th class="text-uppercase text-secondary font-weight-bolder opacity-7">Pavadinimas</th>
                  <th class="text-uppercase text-secondary font-weight-bolder opacity-7">Kaina</th>
                  <th class="text-secondary opacity-7"></th>
                </tr>
              </thead>
              <tbody>
                {#each blocklist(block, "rows") as item}
                <tr>
                  <td>
                    {text(item, 'identifier')}
                  </td>
                  <td>
                    {text(item, 'title')}
                  </td>
                  <td>
                    {text(item, 'price')}
                  </td>
                  <td class="align-middle">
                    <a href="{url(item, 'details')}" class="text-secondary font-weight-bold text-xs" data-toggle="tooltip" data-original-title="Edit user">
                      Pažiūrėti
                    </a>
                  </td>
                </tr>
                {/each}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
